// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c600","content":"styles_content__1ezTY"};